import subCategoryStore from 'js/stores/store';
import subCategoryActions from 'js/actions/actions';
import { filterUndefined, keywordFilteredPack } from 'js/toolbar/filters';
import IconGroups from './iconGroups';

//React Router
import React, { useState } from 'react';

const detailed = ['Detailed', 'Organization'];

let packs = {};
let url = '';
let keywords = '';
let initiated = false;

let init = function() {
  initiated = true;

  packs = subCategoryStore.getState().filteredPacks;

  url = window.location.href.split('?');
  console.log('init!');
  debugger;
  keywords = url.length > 1 ? url[1].split('%20') : detailed;
  if (packs.length === 0) {
    let filteredPacks = JSON.parse(
      JSON.stringify(subCategoryStore.getState().symbologyJson.packs)
    ).map(p => keywordFilteredPack(p, keywords));

    filteredPacks = JSON.parse(JSON.stringify(filteredPacks)).filter(
      filterUndefined
    );
    subCategoryActions.updateFilteredPacks(filteredPacks);

    packs = filteredPacks;
  }

  window.scrollTo(0, 0);
};

let itemSelect = (url, item) => {
  subCategoryActions.updateCurrentIcon(item);

  window.location.assign(
    window.location.pathname + url + '?' + item.keywords.join('%20')
  );
};

let clearStore = k => {
  let filteredPacks = JSON.parse(
    JSON.stringify(subCategoryStore.getState().symbologyJson.packs)
  ).map(p => keywordFilteredPack(p, [k]));

  filteredPacks = JSON.parse(JSON.stringify(filteredPacks)).filter(
    filterUndefined
  );

  subCategoryActions.updateFilteredPacks(filteredPacks);

  setTimeout(function() {
    let elements = document.getElementsByClassName('meta-data');

    for (let i = 0; i < elements.length; i++) {
      elements[i].classList.remove('hidden');
    }

    let subCatList = document.getElementsByClassName('subcategory--list');

    for (let j = 0; j < subCatList.length; j++) {
      subCatList[j].classList.add('flex-column');
    }
    document.getElementById('grid-view').classList.remove('selected');
    document.getElementById('table-view').classList.add('selected');
  }, 500);
  //updateSubcatView.updateSubcatView("table")

  window.location.assign('#/subcat?' + k);
};

class SubCatVeiw extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...subCategoryStore.getState()
    };
    subCategoryStore.subscribe(this.storeUpdated.bind(this));
  }

  storeUpdated() {
    this.setState(subCategoryStore.getState());
  }

  updateCount(num) {
    subCategoryActions.updateCount(num);
  }
  shouldComponenetUpdate() {
    return true;
  }

  addIcon(icon) {
    let itemObj = { item: icon, isAdd: true };
    subCategoryActions.updateMyIcons(itemObj);
  }

  removeIcon(icon) {
    let itemObj = { item: icon, isAdd: false };
    subCategoryActions.updateMyIcons(itemObj);
  }

  componenetDidUpdate() {
    //alert("sdasd")
  }

  render() {
    if (!initiated) {
      init();
    }

    return (
      <div>
        <div
          packnumber={this.props.packnumber}
          className='flex clear subcateogory-packs-container'
        >
          {subCategoryStore.getState().filteredPacks.map(this.Packs, this)}
        </div>
      </div>
    );
  }

  Packs(item) {
    return (
      <div className='flex subcategory-pack-container'>
        <h3 className='pack-title'>{item.name.replace(/_/g, ' ')}</h3>
        <div className='flex subcategory--list'>
          {item.subpacks.map(this.SubPacks, this)}
        </div>
      </div>
    );
  }

  SubPacks(subPack) {
    let icons = (
      <div className='flex subcategory--list'>
        {subPack.icons.map(this.Icons, this)}
      </div>
    );
    if (subPack.groups) {
      icons = <IconGroups subPack={subPack} />;
    }

    return (
      <div className='subcategory-subpack-container'>
        <h4 className='subpack-title'>{subPack.name}</h4>
        {icons}
      </div>
    );
  }

  Icons(item) {
    let isTableView =
      subCategoryStore.getState().subcatView === 'table' ? true : false;
    let hidden = 'hidden';

    if (isTableView) {
      hidden = '';
    }

    return (
      <div className='flex subcategory--list--item-meta border' key={item.id}>
        <div
          id={item.id + '-image-container'}
          className='subcategory--list--item relative'
        >
          <img
            src={
              subCategoryStore.getState().symbologyJson.meta.s3_root_url +
              item.path
            }
          />
          <div
            id={item.id + '-add'}
            onClick={this.iconAdd.bind(this, item)}
            className='add-icon text-white absolute'
          >
            <div>+</div>
          </div>
          <div
            id={item.id + '-remove'}
            onClick={this.iconRemove.bind(this, item)}
            className={'remove-icon ' + hidden + ' text-white absolute'}
          >
            <div>X</div>
          </div>
          <div
            id={item.id + '-view'}
            onClick={itemSelect.bind(this, '#/single', item)}
            className='view-icon text-white absolute'
          >
            <div></div>
          </div>
        </div>
        <div className={'meta-data ' + hidden + ' meta-flex-item'}>
          <div className='meta-data-inner flex'>
            <div>{item.description}</div>
            <div>{item.layer}</div>
            <div>{item.shape}</div>
            <div>
              {item.keywords.map(function(k) {
                return (
                  <div
                    className='margin--small float-left keyword-link pointer'
                    onClick={clearStore.bind(this, k)}
                  >
                    {k}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  //FIX ME TODO
  iconAdd(item) {
    this.addIcon(item);
    document.getElementById(item.id + '-remove').classList.remove('hidden');
    document
      .getElementById(item.id + '-image-container')
      .classList.add('highlight');
    document.getElementById(item.id + '-add').classList.add('hidden');
  }

  iconRemove(item) {
    this.removeIcon(item);
    document.getElementById(item.id + '-add').classList.remove('hidden');
    document
      .getElementById(item.id + '-image-container')
      .classList.remove('highlight');
    document.getElementById(item.id + '-remove').classList.add('hidden');
  }
}

export class SubCategoryPage extends React.Component {
  constructor(props) {
    super(props);
    subCategoryStore.subscribe(this.storeUpdated.bind(this));
  }

  storeUpdated() {
    this.setState(subCategoryStore.getState());
  }

  render() {
    return <SubCatVeiw {...this.state} />;
  }
}



// WEBPACK FOOTER //
// ./src/js/subcategory/subcategoryPage.js